export default class CrossTestViewModel {
    selectedPeriod: string = ''
    arrivalMean: number = 0
    arrivalMedian: number = 0
    arrivalVariation: number = 0
    departureMean: number = 0
    departureMedian: number = 0
    departureVariation: number = 0
    totalMean: number = 0
    totalMedian: number = 0
    totalVariation: number = 0
}

